import { createStyles, keyframes, useMantineTheme } from '@mantine/core';

import { IconBuildingBank } from '@tabler/icons-react';

const loading = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    verificationLoaderBg: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(34px)',
    },
    animationContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '16px',
    },
    transferAnimation: {
      marginTop: '-10px',
      '& p': {
        fontSize: '10px',
        letterSpacing: '4px',
        fontWeight: 400,
        margin: 'auto',
        textAlign: 'center',
      },
      '& span': {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '8px',
        height: '8px',
        margin: '8px',
        background: colors.primary.default,
        borderRadius: '8px',
        animation: `${loading} 1s infinite alternate`,
        '&:nth-of-type(2)': {
          animationDelay: '0.2s',
        },
        '&:nth-of-type(3)': {
          animationDelay: '0.4s',
        },
        '&:nth-of-type(4)': {
          animationDelay: '0.6s',
        },
        '&:nth-of-type(5)': {
          animationDelay: '0.8s',
        },
        '&:nth-of-type(6)': {
          animationDelay: '1.0s',
        },
        '&:nth-of-type(7)': {
          animationDelay: '1.2s',
        },
      },
    },
    heading: {
      marginBottom: '16px',
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '31px',
    },
  };
});

export const BankAccountVerifyLoader = () : JSX.Element => {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const { colors } = theme.other;
  return (
    <div className={classes.verificationLoaderBg}>
      <div className={classes.animationContainer}>
        <IconBuildingBank height={36} width={36} color={colors.primary.default} />
        <div className={classes.transferAnimation}>
          <p>TRANSFERRING</p>
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <IconBuildingBank height={36} width={36} color={colors.primary.default} />
      </div>
      <h2 className={classes.heading}>Verifying your bank account...</h2>
    </div>
  );
};

export default BankAccountVerifyLoader;
